<!-- eslint-disable vue/max-len -->
<template>
  <svg
    v-if="!active"
    v-bind="$attrs"
    :class="`filter-inactive color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00506 6H17.0051L11.9951 12.3L7.00506 6ZM4.25506 5.61C6.27506 8.2 10.0051 13 10.0051 13V19C10.0051 19.55 10.4551 20 11.0051 20H13.0051C13.5551 20 14.0051 19.55 14.0051 19V13C14.0051 13 17.7251 8.2 19.7451 5.61C20.2551 4.95 19.7851 4 18.9551 4H5.04506C4.21506 4 3.74506 4.95 4.25506 5.61Z"
    />
  </svg>
  <svg
    v-else
    v-bind="$attrs"
    class="filter-active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#ebf0f1" />
    <path
      d="M11.0206 20C10.7373 20 10.4998 19.9042 10.3081 19.7125C10.1164 19.5208 10.0206 19.2833 10.0206 19V13L4.22059 5.6C3.97059 5.26667 3.93309 4.91667 4.10809 4.55C4.28309 4.18333 4.58725 4 5.02059 4H19.0206C19.4539 4 19.7581 4.18333 19.9331 4.55C20.1081 4.91667 20.0706 5.26667 19.8206 5.6L14.0206 13V19C14.0206 19.2833 13.9248 19.5208 13.7331 19.7125C13.5414 19.9042 13.3039 20 13.0206 20H11.0206Z"
      fill="#28d567"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
  active?: boolean;
}

withDefaults(defineProps<icon>(), {
  color: 'jewel',
  active: false,
});
</script>
